<template>
      <div class="d-flex justify-content-end mt-0">
        <b-button
          v-b-tooltip.hover.top="'تحديث البيانات'"
          variant="outline-primary"
          class="mr-2"
          :disabled="a.loadMedia"
          @click="a.refreshAttachments"
        >
          <b-spinner
            v-if="a.loadMedia"
            small
            class="mr-1"
          />
          <feather-icon
            v-else
            icon="RefreshCwIcon"
            size="16"
            class="mr-1"
          />
          تحديث
        </b-button>
        <b-button
          v-if="a.isProject168 && a.allSelectableFileIds.length"
          v-b-tooltip.hover.top="'تحديد كل الملفات المتاحة'"
          variant="outline-warning"
          class="mr-2"
          :disabled="a.loadMedia || a.areAllFilesSelected"
          @click="a.selectAllCollectionFiles"
        >
          <feather-icon
            icon="CheckSquareIcon"
            size="16"
            class="mr-1"
          />
          تحديد كل الملفات
        </b-button>
        <b-button
          v-if="a.isProject168 && Array.isArray(a.collectionFilesIds) && a.collectionFilesIds.length"
          v-b-tooltip.hover.top="'تحميل ملف مضغوط للملفات المختارة'"
          variant="outline-success"
          class="mr-2"
          :disabled="a.loadMedia || a.loadDownloadCollectionPackage"
          @click="a.downloadCollectionFilesPackage"
        >
          <b-spinner
            v-if="a.loadDownloadCollectionPackage"
            small
            class="mr-1"
          />
          <feather-icon
            v-else
            icon="DownloadIcon"
            size="16"
            class="mr-1"
          />
          تحميل المرفقات المختارة
        </b-button>
        <b-button
          v-b-tooltip.hover.top="'فتح عرض جميع بيانات الخريطة في تبويب جديد'"
          variant="outline-info"
          class="mr-2"
          @click="a.openMapDataView"
        >
          <feather-icon
            icon="MapIcon"
            size="16"
            class="mr-1"
          />
          عرض بيانات الخريطة
        </b-button>
        <b-button
          variant="primary"
          @click="a.attachFiles = true"
        >
          <span v-b-tooltip.hover.top="'إضافة مرفقات'">
            <feather-icon
              icon="PlusIcon"
              size="16"
            />
          </span>
        </b-button>
      </div>
</template>

<script>
import attachmentsBlockMixin from '../attachmentsBlockMixin'

export default {
  name: 'AttachmentsGalleryFooter',
  mixins: [attachmentsBlockMixin],
}
</script>

<style src="../attachments-shared.scss" lang="scss"></style>
